import { Pipe, PipeTransform } from '@angular/core';
import { PessoaModel } from '@core/models/financeiro/pessoa.model';

@Pipe({name: 'typePeoplePipe'})
export class TypePeoplePipe implements PipeTransform {
  transform(data: PessoaModel): string {
    return data.indicadorCliente ? 'CLIENTE' : data.indicadorConcorrente ? 'CONCORRENTE' : data.indicadorFornecedor ? 'FORNECEDOR' : data.indicadorTerceirizado ? 'TERCEIRIZADO' : '-';
  }
}
